import React from 'react';

import { SVGComponentProps } from './svg.types';

const CalculatorSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block align-middle ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.2 0C1.43269 0 0 1.43269 0 3.2V20.8C0 22.5673 1.43269 24 3.2 24H19.2C20.9673 24 22.4 22.5673 22.4 20.8V3.2C22.4 1.43269 20.9673 0 19.2 0H3.2ZM1.6 3.2C1.6 2.31634 2.31634 1.6 3.2 1.6H19.2C20.0837 1.6 20.8 2.31634 20.8 3.2V6.4C20.8 7.28366 20.0837 8 19.2 8H3.2C2.31634 8 1.6 7.28366 1.6 6.4V3.2ZM2.4 11.2C2.4 10.3163 3.11634 9.6 4 9.6H5.6C6.48366 9.6 7.2 10.3163 7.2 11.2C7.2 12.0837 6.48366 12.8 5.6 12.8H4C3.11634 12.8 2.4 12.0837 2.4 11.2ZM10.4 9.6C9.51634 9.6 8.8 10.3163 8.8 11.2C8.8 12.0837 9.51634 12.8 10.4 12.8H12C12.8837 12.8 13.6 12.0837 13.6 11.2C13.6 10.3163 12.8837 9.6 12 9.6H10.4ZM15.2 11.2C15.2 10.3163 15.9163 9.6 16.8 9.6H18.4C19.2837 9.6 20 10.3163 20 11.2C20 12.0837 19.2837 12.8 18.4 12.8H16.8C15.9163 12.8 15.2 12.0837 15.2 11.2ZM4 14.4C3.11634 14.4 2.4 15.1163 2.4 16C2.4 16.8837 3.11634 17.6 4 17.6H5.6C6.48366 17.6 7.2 16.8837 7.2 16C7.2 15.1163 6.48366 14.4 5.6 14.4H4ZM8.8 16C8.8 15.1163 9.51634 14.4 10.4 14.4H12C12.8837 14.4 13.6 15.1163 13.6 16C13.6 16.8837 12.8837 17.6 12 17.6H10.4C9.51634 17.6 8.8 16.8837 8.8 16ZM16.8 14.4C15.9163 14.4 15.2 15.1163 15.2 16C15.2 16.8837 15.9163 17.6 16.8 17.6H18.4C19.2837 17.6 20 16.8837 20 16C20 15.1163 19.2837 14.4 18.4 14.4H16.8ZM2.4 20.8C2.4 19.9163 3.11634 19.2 4 19.2H5.6C6.48366 19.2 7.2 19.9163 7.2 20.8C7.2 21.6837 6.48366 22.4 5.6 22.4H4C3.11634 22.4 2.4 21.6837 2.4 20.8ZM10.4 19.2C9.51634 19.2 8.8 19.9163 8.8 20.8C8.8 21.6837 9.51634 22.4 10.4 22.4H12C12.8837 22.4 13.6 21.6837 13.6 20.8C13.6 19.9163 12.8837 19.2 12 19.2H10.4ZM15.2 20.8C15.2 19.9163 15.9163 19.2 16.8 19.2H18.4C19.2837 19.2 20 19.9163 20 20.8C20 21.6837 19.2837 22.4 18.4 22.4H16.8C15.9163 22.4 15.2 21.6837 15.2 20.8Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CalculatorSVG;
